<!-- ORGANISATION -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <v-icon v-if="form.organisationStatus === 'APPROVED'"  class="display-1 success--text icons8-checkmark-yes"></v-icon>
                    <v-icon v-if="form.organisationStatus === 'REJECTED'" class="display-1 warning--text icons8-high-importance"></v-icon>
                    <v-icon v-if="form.organisationStatus === 'PENDING'" class="display-1 grey--text icons8-circle"></v-icon>
                    <v-icon v-if="form.organisationStatus === 'SUSPENDED'" class="display-1 grey--text text--lighten-1 icons8-private"></v-icon>

                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <appbutton :label="$t(`buttons.approve`)" v-if="form.organisationStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-checkmark-yes" type="success"  class="mr-0" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />
            <appbutton :label="$t(`buttons.reject`)" v-if="form.organisationStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-high-importance" type="warning"  class="mr-0" @click.native="updateItemStatus('REJECTED')" showlabel="xlOnly" />
            <appbutton :label="$t(`buttons.suspend`)" v-if="form.organisationStatus !== 'SUSPENDED' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-private" type="error"  class="mr-0" @click.native="updateItemStatus('SUSPENDED')" showlabel="xlOnly" />
            <appbutton :label="$t(`buttons.restore`)" v-if="form.organisationStatus === 'SUSPENDED' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-private" type="success"  class="mr-0" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />

        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                            <v-tab href="#people" class="white"><v-icon class="mr-2">icons8-people</v-icon> <span class="caption">{{ $t(`${langPath}.people.tabName`) }} ({{ usersTableData.length }})</span></v-tab>
                            <!-- <v-tab href="#projects" class="white"><v-icon class="mr-2">icons8-project</v-icon> <span class="caption">{{ $t(`${langPath}.projects.tabName`) }} ({{ commentsTableData.length }})</span></v-tab> -->
                            <!-- <v-tab href="#concerns" class="white"><v-icon class="mr-2">icons8-comments</v-icon> <span class="caption">{{ $t(`${langPath}.concerns.tabName`) }} (0)</span></v-tab> -->
                            <v-tab href="#comments" class="white"><v-icon class="mr-2">icons8-chat-messages</v-icon> <span class="caption">{{ $t(`${langPath}.comments.tabName`) }} (0)</span></v-tab>
                        </v-tabs>
                        <!-- // * TABS ITEMS -->
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="d-flex pa-0 ma-0 px-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />
                                            </v-col>
                                        </v-row>
                                        <!-- // * FORM -->
                                        <v-form ref="form">
                                        <v-row class="mt-2 mb-12" no-gutters>
                                            <!-- DETAILS -->
                                            <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <h5 class="grey--text text--darken-1">DETAILS</h5>
                                                <v-divider class="" />
                                            </v-col>

                                            <v-col  v-if="formMode === 'Edit' || formMode === 'New'" class="px-2 my-2 d-flex align-center justify-center" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-row class="ma-0"  v-if="uploadedFile === undefined || uploadedFile === null" :allowedTypes="types">
                                                    <dragdrop :allowedTypes="types" :storagePath="storagePathProfilePic" :maxWidth="'200'"/>
                                                     <v-col cols="12" class="ma-0 px-0 pb-0 pt-1">
                                                        <uploadFilesButton  :storagePath="storagePathProfilePic"/>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-else>
                                                    <v-col v-if="uploadedFile != null">
                                                        <v-img max-width="220" height="250" contain style="border-radius: 5px" :src="uploadedFile.fileURL"></v-img>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col v-else class="px-2 my-2 d-flex align-center justify-center" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-row v-if="form.organisationImageURL != null" class="ma-0">
                                                    <v-img max-width="220" height="250" contain style="border-radius: 5px" :src="form.organisationImageURL"></v-img>
                                                </v-row>
                                                <v-row v-else class="justify-center ">
                                                    <v-col class="mt-6 d-flex align-center justify-center" cols="12" >
                                                        <v-icon size="50">icons8-image-document</v-icon>
                                                    </v-col>
                                                    <v-col class="d-flex align-center justify-center" cols="12" >
                                                         <h3 class="grey--text text--darken-3">{{ $t('fields.noImage')}}</h3>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
                                                <v-text-field color="black" class="py-2" v-model="form.organisationName" filled hide-details="auto" required :rules="rules.organisationName" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" :label=" $t('fields.name')"></v-text-field>
                                                <v-text-field color="black" :label=" $t('fields.telephone')"  class="py-2" v-model="form.organisationTelephone" filled hide-details="auto" required :rules="rules.organisationTelephone" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label=" $t('fields.type')"  class="py-2" v-model="form.organisationType" :items="organisationTypes" item-text="text" item-value="value" dense filled hide-details="auto" required :rules="rules.organisationType" :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                    <template v-slot:item="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                </v-select>
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black" :label=" $t('fields.status')"  class="py-2" v-model="form.organisationStatus" :items="organisationStatus" item-text="text" item-value="value" dense filled hide-details="auto" required :rules="rules.organisationStatus" :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                    <template v-slot:item="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                </v-select>
                                            </v-col>

											<!-- ORGANISATION ADMIN -->
											<v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
												<h5 class="grey--text text--darken-1">ORGANISATION ADMIN</h5>
												<v-divider class="pb-3" />
                                                <span class="darkgrey--text">This is the person responsible for onboarding (e.g Approve, Reject, Suspend). Due to this, this person must have a manager or admin user role.</span>
											</v-col>
											<v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
												<!-- <v-autocomplete color="black"  autocomplete="donotautocomplete" :label="$t(`fields.host`)" v-model="form.host" :items="approvedUsers" return-object filled hide-details="auto" :rules="rules.host" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">
															{{ data.item.userName }}
															<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
														</template>
														<template v-slot:selection="data">
															{{ data.item.userName }}
															<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
														</template>
													</v-autocomplete> -->
												<v-autocomplete attach="" color="black" autocomplete="donotautocomplete" :rules="rules.host" :label="$t(`fields.host`)" v-model="form.host" :items="hosts" item-text="userName" hide-details="auto" required return-object filled :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
													<template v-slot:item="data">{{ data.item.userName }} <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template>
													<template v-slot:selection="data">{{ data.item.userName }} <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template>
												</v-autocomplete>
											</v-col>

                                            <!-- ADDRESS -->
                                            <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <h5 class="grey--text text--darken-1">ADDRESS</h5>
                                                <v-divider class="" />
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.addressLine1" :label=" $t('fields.addressLine1')" hide-details="auto" required :rules="rules.addressLine1" append-icon="icons8-address" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" ></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.addressLine2" :label=" $t('fields.addressLine2')" hide-details="auto" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" append-icon="icons8-address" ></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.addressLine3" :label=" $t('fields.addressLine3')" hide-details="auto" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" append-icon="icons8-address" ></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.town" :label=" $t('fields.town')" hide-details="auto" required :rules="rules.addressTown" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" append-icon="icons8-city" ></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.county" :label=" $t('fields.county')" hide-details="auto" append-icon="icons8-map-marker" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" ></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field color="black" filled :background-color="formBackground" v-model="form.address.postcode" :label=" $t('fields.postcode')" hide-details="auto" required :rules="rules.addressPostcode" append-icon="icons8-map-marker" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }" ></v-text-field>
                                            </v-col>
                                            <!-- INFO -->
                                            <v-col class="my-2 px-2 mb-12" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="formMode !== 'New'">
                                                <v-divider/>
                                                <div class="caption grey--text text--darken-1 pt-2">
                                                    <strong>{{$t('fields.created')}}:</strong> {{ form.createdUserData.userName }} - {{ form.createdUserData.organisationName }} - {{ MIX_formatDateTime(form.createdDateTime, 'x', 'DD-MMM-YYYY') }} |
                                                    <strong>{{$t('fields.modified')}}:</strong> {{ form.modifiedUserData.userName }} - {{ form.modifiedUserData.organisationName }} - {{ MIX_formatDateTime(form.modifiedDateTime, 'x', 'DD-MMM-YYYY') }}
                                                </div>
                                            </v-col>
                                            <v-col  class="my-10"></v-col>
                                        </v-row>
                                        </v-form>
                                        <!-- <pre align="left">{{ form }}</pre> -->
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- PEOPLE -->
                            <v-tab-item value="people" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <v-col cols="12" class="px-2">
                                                <app-text category="tab-title">{{ $t(`${langPath}.people.title`) }}</app-text>
                                                <app-text category="tab-text">{{ $t(`${langPath}.people.text`) }}</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                            <v-col class="pa-0 d-flex pl-2 pr-1 align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">ID</div>
                                                <v-switch v-model="showIDUsers" class="ml-4 secondary--text" inset></v-switch>
                                                <div class="font-weight-bold grey--text"><v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon></div>
                                                <v-switch @change="getUsers(GET_openItem)" v-model="showDeletedUsers" class="ml-4 secondary--text" inset></v-switch>
                                            </v-col>
                                            <v-col cols="12" class="my-4 px-2">
                                                <v-data-table
                                                    :headers="computedUsersHeaders"
                                                    :items="computedUsersTableData"
                                                    :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                                                    item-key="id"
                                                    class="elevation-0"
                                                    dense
                                                    hide-default-header
                                                    >
                                                        <!-- // HEADERS -->
                                                        <template v-slot:header="{ props }">
                                                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                                                {{ $t(`fields.${head.text}`) }}
                                                            </th>
                                                        </template>
                                                        <!-- // STATUS -->
                                                        <template v-slot:[`item.userStatus`]="{ item }">
                                                            <v-icon v-if="item.userStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.userStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                                                            <v-icon v-if="item.userStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                            <v-icon v-if="item.userStatus === 'SUSPENDED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>
                                                        </template>
                                                        <!-- // USERNAME -->
                                                        <template v-slot:[`item.userName`]="{ item }">
                                                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="error--text"><v-icon class="error--text">icons8-trash</v-icon> {{ item.userName}}</span>
                                                            <span v-else>{{ item.userName }}</span>
                                                        </template>
                                                        <!-- // CREATED USER DATA -->
                                                        <template v-slot:[`item.createdUserData`]="{ item }">
                                                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.createdUserData.userName }}<br />
                                                                <span class="caption">{{ item.createdDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // MODIFIED USER DATA -->
                                                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                                                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.modifiedUserData.userName }}
                                                                <span class="caption">{{ item.modifiedDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // DELETE USER DATA -->
                                                        <template v-slot:[`item.deleteUserData`]="{ item }">
                                                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.deleteUserData.userName }}
                                                                <span class="caption">{{ item.delete }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // ACTIONS -->
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <v-icon @click="MIX_popupUser(item.id)">icons8-identification-documents</v-icon>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item value="projects" class="pa-0">
                                <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="ma-0 pl-3 pr-2">
                                            <v-col cols="12" class="pa-1">
                                                <app-text category="tab-title">{{ $t(`${langPath}.projects.title`) }}</app-text>
                                                <app-text category="tab-text">{{ $t(`${langPath}.projects.text`) }}</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item value="concerns" class="pa-0">
                                <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="ma-0 pl-3 pr-2">
                                            <v-col cols="12" class="pa-1">
                                                <app-text category="tab-title">{{ $t(`${langPath}.concerns.title`) }}</app-text>
                                                <app-text category="tab-text">{{ $t(`${langPath}.concerns.text`) }}</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- HISTORY / COMMENTS -->
                            <v-tab-item value="comments" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <v-col cols="12" class="px-2">
                                                <app-text category="tab-title">{{$t(`${langPath}.comments.tabName`)}}</app-text>
                                                <app-text category="tab-text">{{$t(`${langPath}.comments.text`)}}</app-text>
                                                <v-divider class="mt-4"/>
                                            </v-col>
                                            <v-col class="d-flex pa-0 ma-0 pl-1 d-flex align-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_comment({ show: true, action: 'New', data: { comment: '', private: true, docLink: { collection: 'organisation', documentId: form.id } } })" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">ID</div>
                                                <v-switch v-model="showIDComments" class="ml-4 secondary--text" inset></v-switch>
                                                <div class="font-weight-bold grey--text"><v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon></div>
                                                <v-switch @change="getComments(GET_openItem)" v-model="showDeletedComments" class="ml-4 secondary--text" inset></v-switch>
                                            </v-col>

                                            <v-col cols="12" class="my-2 px-2">
                                                <v-data-table
                                                    id="commentstable"
                                                    :headers="computedCommentsHeaders"
                                                    :items="computedCommentsTableData"
                                                    :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                                                    item-key="id"
                                                    class="elevation-0"
                                                    dense
                                                    hide-default-header
                                                    >
                                                        <!-- // STATUS -->
                                                        <template v-slot:[`item.concernStatus`]="{ item }">
                                                            <v-icon v-if="item.concernStatus === 'RESOLVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                        <!-- // HEADERS -->
                                                        <template v-slot:header="{ props }">
                                                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                                                {{ $t(`fields.${head.text}`) }}
                                                            </th>
                                                        </template>
                                                        <template v-slot:[`item.comment`]="{ item }">
                                                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="error--text"><v-icon class="error--text">icons8-trash</v-icon> {{ item.comment}}</span>
                                                            <span v-else>{{ item.comment }}</span>
                                                        </template>
                                                        <template v-slot:[`item.private`]="{ item }">
                                                            <v-icon v-if="item.private === true">icons8-lock</v-icon>
                                                            <v-icon v-if="item.private === false"></v-icon>
                                                        </template>
                                                        <!-- // DOC LINK -->
                                                        <template v-slot:[`item.docLink`]="{ item }">
                                                            {{ item.docLink.documentId }}
                                                        </template>
                                                        <!-- // CREATED USER DATA -->
                                                        <template v-slot:[`item.createdUserData`]="{ item }">
                                                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.createdUserData.userName }}<br />
                                                                <span class="caption">{{ item.createdDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // MODIFIED USER DATA -->
                                                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                                                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.modifiedUserData.userName }}
                                                                <span class="caption">{{ item.modifiedDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // DELETE USER DATA -->
                                                        <template v-slot:[`item.deleteUserData`]="{ item }">
                                                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>
                                                                {{ item.deleteUserData.userName }}
                                                                <span class="caption">{{ item.delete }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- ACTIONS -->
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <div class="actionscolumn">
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="MIX_comment({ show: true, action: 'Edit', data: { id: item.id, comment: item.comment, private: item.private } })">icons8-edit-property</v-icon>
                                                                <v-icon v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" @click="MIX_undelete('comments', 'Comment', item.id)">icons8-process</v-icon>
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="deleteComment(item)">icons8-trash</v-icon>
                                                            </div>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapState } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'organisations',
            collectionTitle: 'Organisations',
            collectionItem: 'organisation',
            collectionItemTitle: 'Organisation',
            langPath: 'organisations.organisation',
            tabs: 'overview',
            // * FORM RELATED
            form: {
            //    id: '', // remove
                organisationName: '',
                organisationType: '',
                organisationStatus: '',
                organisationTelephone: '',
                organisationImageURL: null,
                address: {
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    town: '',
                    county: '',
                    postcode: ''
                },
                comments: [],
                createdUserData: {},
                createdDateTime: '',
                modifiedUserData: {},
                modifiedDateTime: '',
                host: [],
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            // * ORGANISATION UPLOAD IMAGE
            types: "image/*" ,
            storagePathProfilePic: 'organisations-pictures',
            // * COMMENTS RELATED
            commentsTableData: [], // populated from firestore on show comments
            commentsHeaders: [
                { text: 'private',  value: 'private', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'id', value: 'id', align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'comment', value: 'comment', align: 'start', sortable: false, hidden: false, hide: false, },
                { text: 'docLink', value: 'docLink', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'delete',   value: 'delete',  align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
            ],
            showDeletedComments: false, // Show Deleted Comments
            showIDComments: false,

            // * ORGANISATION RELATED
            organisationTypes: [], // POPULATED FROM GETTER
            organisationStatus: [], // POPULATED FROM GETTER

            // * USERS RELATED
            usersTableData: [],
            usersHeaders: [
                { text: 'status', value: 'userStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'start', hidden: true, hide: true },
                { text: 'name',  value: 'userName', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'email', value: 'userEmail', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'telephone', value: 'userTelephone', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'userType', value: 'userType', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'userRole', value: 'userRole', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'jobTitle', value: 'userJobTitle', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'delete',   value: 'delete',  align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', sortable: false, sortable: false, hidden: false, align: 'center' },
            ],
            showDeletedUsers: false, // Show Deleted Comments
            showIDUsers: false,

            approvedUsers: [],
            hosts: []

        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openOrganisation', // Get Open notice Data
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
                GET_openOrganisation: 'GET_openOrganisation', // Get Open Project Data
                GET_lookupValues: 'GET_lookupValues',
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help'
            }),
            ...mapState({
                uploadedFile: (state) => state.upload_file_store.file
            }),
            // check this
            // computedUsersHeaders() {
            //     var t = this;
            //     var headers = t.usersHeaders;

            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Computed Users headers
            computedUsersHeaders() {
                var t = this;
                var headers = t.usersHeaders;
                var newHeaders = []
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i]
                    if (header.hidden) {
                        switch (true) {
                            // Add in Cases that need to be manually controlled
                            case (header.text === 'id'):
                                if (t.showIDUsers) { newHeaders.push(header) } // remove if false
                                break;
                            case (header.text === 'deleteUserData'):
                                if (t.showDeletedUsers) { newHeaders.push(header) } // remove if false
                                break;
                            default:
                                // do nothing

                        }
                    } else {
                        newHeaders.push(header)
                    }
                }
                return newHeaders
            },
            // Computed Table Data
            computedUsersTableData() {
                var t = this;
                var tableData = t.usersTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        userStatus: e.userStatus,
                        id: e.id,
                        userName: e.userName,
                        userEmail: e.userEmail,
                        userTelephone: e.userTelephone,
                        userType: e.userType,
                        userRole: e.userRole,
                        userJobTitle: e.userJobTitle,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);
            },


            // COMPUTED COMMENTS HEADERS (GENERIC)
            computedCommentsHeaders() {
                var t = this;
                var headers = t.commentsHeaders;
                var newHeaders = []
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i]
                    if (header.hidden) {
                        switch (true) {
                            // Add in Cases that need to be manually controlled
                            case (header.text === 'id'):
                                if (t.showIDComments) { newHeaders.push(header) } // remove if false
                                break;
                            case (header.text === 'deleteUserData'):
                                if (t.showDeletedComments) { newHeaders.push(header) } // remove if false
                                break;
                            default:
                                // do nothing

                        }
                    } else {
                        newHeaders.push(header)
                    }
                }
                return newHeaders
            },
            // COMPUTED COMMENTS TABLE DATA (GENERIC)
            computedCommentsTableData() {
                var t = this;
                var tableData = t.commentsTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        private: e.private,
                        id: e.id,
                        comment: e.comment,
                        docLink: e.docLink,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);
            }
        },
        // * WATCH
        watch: {
            // GET CONFIRMATION RESULT
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === t.collection) {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null);
                                t.refreshItemView();
                            } else {
                                t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'concerns') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Concern Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Concern', null, deleteResult.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'comments') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Comment Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Comment', null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing

                    }
                }, deep: true
            },




            // Watch for a change in the Open Project Data and then Update the Breadcrumbs
            // GET_openOrganisation: {
            //     handler() {
            //         this.updateBreadcrumbs();
            //     }, deep: true
            // },
            GET_datePickerResult: {
                // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
                handler() {
                    switch (this.GET_datePickerResult.field) {
                        // case 'projectStartDate':
                        //     this.form.startDate = this.GET_datePickerResult.value; // Update the Form Start Date
                        //     this.formattedProjectStartDate = this.MIX_formatDateTime(this.form.startDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project Start Date
                        //     break;
                        // case 'projectEndDate':
                        //     this.form.endDate = this.GET_datePickerResult.value; // Update the Form End Date
                        //     this.formattedProjectEndDate = this.MIX_formatDateTime(this.form.endDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project End Date
                        //     break;
                        default:
                            //do nothing
                            break
                    }
                }, deep: true
            },
            // watch for changes to the file in the store
            uploadedFile: {
                handler: function() {
                    this.uploadedFile;
                },
                deep: true
            },


        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openNotice', 'ACT_openUser': 'ACT_openUser'}),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New':
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit':
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }
                return;
            },
            // EDIT ITEM
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();
                t.closeRightPanel();
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }                
                // if(t.uploadedFile != null){
                //     t.form.fileData.fileURL = t.uploadedFile.fileURL;
                //     t.form.fileData.fileType = t.uploadedFile.fileType;
                //     t.form.fileData.fileName = t.uploadedFile.fileName;
                // }
                //  if(this.uploadedFile != null){
                //     this.form.organisationImageURL = this.uploadedFile.fileURL;
                // }
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                    t.removeUploadedDocument();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    organisationName: [
                        v => !!v || 'Organisation Name is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    ],
                    organisationTelephone: [v => !!v || 'Organisation Telephone Required'],
                    organisationType: [v => !!v || "Organisation Type Required"],
                    organisationStatus: [v => !!v || "Organisation Status Required"],
                    addressLine1: [v => !!v || "Address Required"],
                    addressTown: [v => !!v || 'Town Required'],
                    addressPostcode: [v => !!v || 'Postcode Required'],
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {
                        //t.MIX_alert(1, "Passed validation.", null, null);
                        //it’s valid, do work
						// t.MIX_confirmBox (
                    	// 	{
                        // 		show: true,
                        // 		collection: t.collection,
                        // 		id: t.form.id,
                        // 		title: `New Project`,
                        // 		description: `Please confirm that all the information given is correct`,
                        // 		width: '300',
                        // 		height: '300',
                        // 		trueButtonText: 'Yes',
                        // 		trueButtonValue: 'YES',
                        // 		falseButtonText: 'No',
                        // 		falseButtonValue: 'NO',
      		            //   	}
			            // )
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error);
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    {
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`,
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },

            // // Save Organisation
            // saveOrganisation: async function() {
            //     // TODO - NOT TESTED
            //     if(this.uploadedFile != null){
            //         this.form.organisationImageURL = this.uploadedFile.fileURL;
            //     }
            //     var organisation = this.form;
            //     if (organisation.id === '') { delete organisation.id }
            //     var createDocumentResult = await this.MIX_createDocument('organisations', organisation); // Create Document Within Firestore based on Form
            //     if (createDocumentResult.code === 1) {
            //         this.MIX_alert(1, 'Organisation Saved', null, null); // Send Success Alert to Organisation
            //         this.formMode = 'View'; // Change Form Mode
            //         this.formReadOnly = true; // Set Form to Read Only
            //     } else {
            //         this.MIX_alert(-1, 'Error Saving Organisation', null, null); // Send Error Alert to Organisation
            //     }

            // },

            // GET USERS METHOD
            getUsers: async function (openItem) {
                return new Promise((resolve) => {
                    var t = this;
                    if (JSON.stringify(openItem.data) !== '{}') {
                        t.$firebase.db
                            .collection('users').where("organisation.organisationId", "==", openItem.data.id)
                            .onSnapshot(function(querySnapshot) {
                                t.usersTableData = [];
                                querySnapshot.forEach(function(doc) {
                                    var document = doc.data()
                                    document.id = doc.id;
                                    if (!document.hasOwnProperty('delete')) {
                                        t.usersTableData.push(document);
                                    } else if (t.showDeletedUsers) {
                                         t.usersTableData.push(document);
                                    } else {
                                        // Do not Show Notice
                                    }
                                });
                                resolve();
                        });
                    }
                })
            },
            // * COMMENTS RELATED METHODS
            // GET COMMENTS METHOD
            getComments: async function (openItem) {
                var t = this;
                if (JSON.stringify(openItem.data) !== '{}') {
                    t.$firebase.db.collection('comments').where("docLink.documentId", "==", openItem.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.commentsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.commentsTableData.push(document);
                                } else if (t.showDeletedComments) {
                                     t.commentsTableData.push(document);
                                } else {
                                    // Do not Show Notice
                                }
                            });
                    });
                }
            },
            // DELETE COMMENT METHOD
            deleteComment: function (item) {
                this.MIX_confirmBox(
                    {
                        show: true,
                        collection: 'comments',
                        id: item.id,
                        title: 'Delete Comment',
                        description: `Are you sure you want to delete comment: <strong>${item.comment}</strong>?`,
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },

            // Get Approved Users
            getApprovedUsers() {
                var t = this;
                var tableData = t.usersTableData.filter(function (user) {
                    return ((user.userStatus === 'APPROVED' && (user.userRole === 'MANAGER' || user.userRole === 'ADMIN')))
                });
                var tableDataList = tableData.map(e => {
                    return {
                        userId: e.id,
                        userJobTitle: e.userJobTitle,
                        userName: e.userName,
                        userEmail: e.userEmail,
                    };
                });
                return (tableDataList);
            },

        },
        async mounted() {
            var t = this;
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.organisationTypes = await t.GET_lookupValues('ORGANISATIONTYPES');
            t.organisationStatus = await t.GET_lookupValues('ORGANISATIONSTATUS');
            // remove any uploaded file from store
            this.$store.commit("upload_file_store/setFile", null);
            

            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
                    var hostsResult = await t.MIX_readDocuments('users');
                    hostsResult = hostsResult.data
                    
                    hostsResult = hostsResult.filter(function(item) {
                        return item.userStaffContact === true && item.userStatus == 'APPROVED'
                    })

                    t.hosts = hostsResult.map(user => {
                        return {
                            userId: user.id,
                            userName: user.userName,
                            userEmail: user.userEmail,
                            userJobTitle: user.userJobTitle,
                            organisationId: user.organisation.organisationId,
                            organisationName: user.organisation.organisationName
                        }
                    })
                    t.hosts = t.$sortBy(t.hosts, 'userName');
            if (openItem.process === 'New') {
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                // * USER RELATED MOUNTED
                await t.getUsers(openItem);
                t.getComments(openItem); // Get Comments for OpenItem

            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title


            t.approvedUsers = t.getApprovedUsers()
            // console.log('approvedUsers \n' + JSON.stringify(t.approvedUsers, null, 2))

        }
    };
</script>


<style scoped>
    #commentstable td {
        vertical-align: top !important;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }
    .fixedcolumn {
        min-width: 130px !important;
        width: 130px !important;
    }
    .actionscolumn {
        min-width: 50px !important;
        width: 50px !important;

    }
    .disabled {
        pointer-events:none;
        cursor: not-allowed;
    }
	.disabled >>> .v-input__slot::before {
		border-style: none !important;
	}

	 .v-autocomplete__content {
		 max-height: 46vh !important;
	 }
</style>
